<!-- <div id="app-map-{{id}}"></div> -->

<!-- <div style="height: 600px;" leaflet [leafletOptions]="options" [leafletLayers]="layers"> -->
<div id="map-{{mapId}}" style="height: 600px;z-index: 2"></div>
